/*
CONFIG FILE STRUCT and ARGUMENTS
`envx.config.js`
module.exports = {
  input: "./examples/.envx",
  outputs: {
    env: "./examples/.env",
    types: "./examples/envx.ts",
    metaFilePath: "./examples", // Only Folder path (not include file name)
  },
  overwrite: true,
};

`envx.config.json`
{
  "input": "./examples/.envx", // Path to your .envx file
  "outputs": {
    "env": "./examples/.env", // Output .env file path
    "types": "./examples/envx.ts", // Output TypeScript definition file
    "metaFilePath": "./examples" // Folder where meta JSON will be placed (file name is fixed)
  },
  "overwrite": true // If true, existing .env will be overwritten without prompt
}


input -> Specifies the path to the .envx file
outputs -> used to specify output files
  env -> Used to specify the path of the .env file to be converted from .envx
  types -> to specify the path to the typescript type file to create
  [NEW] metaFilePath -> It is a json file with type etc. data to be created with .env during build, only the folder pathh name can be specified.
overwrite (true/false) -> If .env is present at the time of conversion and the value is true, it is overwritten directly, no questions asked 

*/

import path from "path";
// import { pathToFileURL } from "url";
import { existsSync, readFileSync } from "fs";

export const defaultUserConfig = {
  input: "./.envx",
  outputs: {
    env: "./.env",
    types: "./types/envx.ts",
    metaFilePath: ".",
  },
  overwrite: false,
};

export function loadUserConfig() {
  const jsConfigFileName = "envx.config.js";
  const jsonConfigFileName = "envx.config.json";

  const jsonPath = path.resolve(jsonConfigFileName);
  const jsPath = path.resolve(process.cwd(), jsConfigFileName);

  if (existsSync(jsonPath)) {
    const raw = readFileSync(jsonPath, "utf-8");
    try {
      return JSON.parse(raw);
    } catch (error) {
      console.warn(
        "[envx:info:config] Failed to parse envx.config.json, using default config."
      );
      return defaultUserConfig;
    }
  }

  if (existsSync(jsPath)) {
    // const url = pathToFileURL(fullPath).href; [OLD_VERSION(v0.0.102)]
    // const config = await import(url); [OLD_VERSION(v0.0.102)]

    try {
      const config = require(jsPath);
      return config;
    } catch (error) {
      console.warn(
        "[envx:info:config] Failed to load envx.config.js. This file is only supported in CommonJS environments. " +
          "Please try using 'envx.config.json' or check your project configuration."
      );

      return defaultUserConfig;
    }
  }

  return defaultUserConfig;
}
